"use client";

import { useEffect } from "react";
import useLayoutStore from "@/Web/Stores/layoutStore";

export type TFLayoutMetaProps = {
  title: string;
  description: string;
  icon?: React.ReactNode;
};

interface TFLayoutMetaComponentProps {
  meta?: TFLayoutMetaProps;
}

const TFLayoutMeta = ({ meta }: TFLayoutMetaComponentProps) => {
  const storeMeta = useLayoutStore((state) => state.meta);

  // Используем meta из пропса или из store
  const effectiveMeta = meta || storeMeta;

  useEffect(() => {
    if (effectiveMeta) {
      // Устанавливаем title
      document.title = effectiveMeta.title;

      // Устанавливаем meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", effectiveMeta.description);
    }
  }, [effectiveMeta]);

  // Если meta передан в пропсах, сохраняем его в store
  useEffect(() => {
    if (meta) {
      useLayoutStore.getState().setMeta(meta);
    }
  }, [meta]);

  return null;
};

export default TFLayoutMeta;
